import React, { forwardRef, useRef, useEffect } from "react"
import * as THREE from "three"
import { ReactThreeFiber, extend, useThree, useFrame } from "react-three-fiber"
import { PointerLockControls as PointerLockControlsImpl } from "three/examples/jsm/controls/PointerLockControls"
// @ts-ignore
import mergeRefs from "react-merge-refs"
// import { useControl } from "react-three-gui"

extend({ PointerLockControlsImpl })

type PointerLockControls = ReactThreeFiber.Object3DNode<
  PointerLockControlsImpl,
  typeof PointerLockControlsImpl
>

declare global {
  namespace JSX {
    // eslint-disable-next-line @typescript-eslint/interface-name-prefix
    interface IntrinsicElements {
      pointerLockControlsImpl: PointerLockControls
    }
  }
}

// controls
var moveForward = false
var moveBackward = false
var moveLeft = false
var moveRight = false
var canJump = false

var prevTime = performance.now()
var velocity = new THREE.Vector3()
var direction = new THREE.Vector3()

type Props = {
  locked: boolean
}

const PointerLockControlsComponentName = forwardRef((props: Props, ref) => {
  const controls = useRef<PointerLockControlsImpl>()
  const { camera, gl, invalidate } = useThree()
  // const { locked } = props
  const enabled = false

  useFrame(() => {
    if (controls.current?.isLocked === true && enabled) {
      var time = performance.now()
      var delta = (time - prevTime) / 1000

      const vlocityCoeff = 15.0

      velocity.x -= velocity.x * vlocityCoeff * delta
      velocity.z -= velocity.z * vlocityCoeff * delta

      velocity.y -= 9.8 * 100.0 * delta // 100.0 = mass

      direction.z = Number(moveForward) - Number(moveBackward)
      direction.x = Number(moveRight) - Number(moveLeft)
      direction.normalize() // this ensures consistent movements in all directions

      if (moveForward || moveBackward) velocity.z -= direction.z * 200.0 * delta
      if (moveLeft || moveRight) velocity.x -= direction.x * 200.0 * delta

      controls.current?.moveRight(-velocity.x * delta)
      controls.current?.moveForward(-velocity.z * delta)

      // if (controls.current?.getObject().position.y < 10) {
      //   velocity.y = 0
      //   canJump = true
      // }

      prevTime = time
    }
  })

  // const controlsLocked = useControl("Toggle Controls", {
  //   type: "button",
  //   onClick() {
  //     toggleLock()
  //   },
  // })

  // useEffect(() => {
  //   if (locked) {
  //     toggleLock()
  //     // alert("locked")
  //   }
  // }, [locked])

  const toggleLock = (e: any) => {
    // console.log(e.target.tagName)

    const isLocked = controls.current?.isLocked
    const linkClicked = e.target.tagName === "A"
    if (!isLocked && !linkClicked) {
      velocity = new THREE.Vector3()
      controls.current?.lock()
    } else {
      controls.current?.unlock()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown, false)
    document.addEventListener("keyup", onKeyUp, false)
    document.addEventListener("click", toggleLock)
    
    return () => {
      document.removeEventListener("keydown", onKeyDown, false)
      document.removeEventListener("keyup", onKeyUp, false)
      document.removeEventListener("click", toggleLock)
    }
  }, [])

  const onKeyDown = function (event: any) {
    switch (event.keyCode) {
      case 38: // up
      case 87: // w
        moveForward = true
        break

      case 37: // left
      case 65: // a
        moveLeft = true
        break

      case 40: // down
      case 83: // s
        moveBackward = true
        break

      case 39: // right
      case 68: // d
        moveRight = true
        break

      case 32: // space
        if (canJump === true) velocity.y += 350
        canJump = false
        break
    }
  }

  const onKeyUp = function (event: any) {
    switch (event.keyCode) {
      case 38: // up
      case 87: // w
        moveForward = false
        break

      case 37: // left
      case 65: // a
        moveLeft = false
        break

      case 40: // down
      case 83: // s
        moveBackward = false
        break

      case 39: // right
      case 68: // d
        moveRight = false
        break
    }
  }

  useEffect(() => {
    let thing = controls.current
    thing?.addEventListener("change", invalidate)
    return () => thing?.removeEventListener("change", invalidate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controls.current])
  return (
    <pointerLockControlsImpl
      ref={mergeRefs([controls, ref])}
      args={[camera, gl.domElement]}
      {...props}
    />
  )
})

export default PointerLockControlsComponentName
